import {
  MODULES,
  getDiagnosisTooltipMode,
  renderCompanyCell,
  renderDiagnosisCell,
  renderUsersCell,
} from "./helpers";

const CENTERED_CELL = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const buildCompanyColumn = () => ({
  colId: "nombre",
  headerName: "Empresa",
  flex: 2.4,
  minWidth: 260,
  sortable: true,
  cellStyle: { display: "flex", alignItems: "center" },
  tooltipValueGetter: (params) =>
    params.data && params.data.nombre ? params.data.nombre : null,
  cellRenderer: renderCompanyCell,
});

const buildDiagnosisColumn = (mod, isAdmin) => {
  const column = {
    colId: mod.key,
    headerName: mod.label,
    width: mod.key === "leader" ? 160 : 110,
    sortable: true,
    sortingOrder: ["desc", "asc", null],
    headerClass: "em-header-center",
    cellClass: (params) => (params.data ? "em-cell-click" : ""),
    cellStyle: CENTERED_CELL,
    cellRenderer: renderDiagnosisCell,
    onCellClicked: (params) =>
      params.context.componentParent.handleDiagnosisClick(params),
  };
  if (mod.tip) column.headerTooltip = mod.tip;
  if (isAdmin) {
    column.tooltipComponent = "diagnosisTooltip";
    column.tooltipValueGetter = (params) =>
      getDiagnosisTooltipMode(params.data, mod.key);
  }
  return column;
};

const buildUsersColumn = () => ({
  colId: "users",
  headerName: "Usuarios",
  width: 110,
  headerClass: "em-header-center",
  headerTooltip: "Usuarios en la empresa",
  cellStyle: CENTERED_CELL,
  cellRenderer: renderUsersCell,
});

const buildActionsColumn = () => ({
  colId: "_actions",
  headerName: "Acciones",
  width: 150,
  headerClass: "em-header-right",
  suppressNavigable: true,
  cellStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  cellRenderer: "companyActions",
});

export const buildColumnDefs = (isAdmin) => {
  const columns = [buildCompanyColumn()];
  MODULES.forEach((mod) => {
    columns.push(buildDiagnosisColumn(mod, isAdmin));
  });
  if (isAdmin) columns.push(buildUsersColumn());
  columns.push(buildActionsColumn());
  return columns;
};

export const ADMIN_COLUMNS = buildColumnDefs(true);
export const CLIENT_COLUMNS = buildColumnDefs(false);



// WEBPACK FOOTER //
// ./src/components/empresas/columns.js